
export async function parseStyle(gpxString: string) {
  const xml: XMLDocument = new window.DOMParser().parseFromString(gpxString, "text/xml");
  const gpxProps = xml.getRootNode().firstChild?.childNodes[3]
    .childNodes[5].childNodes[1];
  return {
    color: gpxProps?.childNodes[1].firstChild?.nodeValue,
    opacity: gpxProps?.childNodes[3].firstChild?.nodeValue,
    weight: gpxProps?.childNodes[5].firstChild?.nodeValue
  };
}
